import { request as sonataRequest } from 'sonata-react-components';

export type KeyToReview = {
  fileCpy: string;
  key: string;
  type: string | null;
};

export type UploadWhiteBlackListing = {
  delimiter: {
    columnDelimiter: string;
    lineDelimiter: string;
  };
  fileName: string;
  keysToReview: KeyToReview[];
  totalLines: number;
};

export async function uploadWhiteBlackListing(
  campaignId: string,
  file: File,
  sessionId: string,
  user: string
): Promise<UploadWhiteBlackListing> {
  const params = new URLSearchParams({
    name: encodeURIComponent(file.name)
  }).toString();
  const res = await fetch(
    `${taptap.config.backendUrlBase}batch/import/whiteBlackListing/file/channel/${campaignId}?${params}`,
    {
      body: new Blob([file]),
      headers: {
        'Content-Type': 'text/csv',
        'X-Requested-With': 'XMLHttpRequest',
        sessionId,
        user
      },
      method: 'POST'
    }
  );
  const data = await res.json();
  return data;
}

export async function processWhiteBlackListing(
  campaignId: string,
  data: UploadWhiteBlackListing,
  type: 'generic' | 'specific'
): Promise<any> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}batch/import/whiteBlackListing/campaign/${campaignId}`,
    {
      data: {
        ...data,
        keysToReview: data.keysToReview.map(({ fileCpy: fileCol, ...rest }) => ({
          ...rest,
          fileCol
        }))
      },
      method: 'POST',
      params: {
        socketEvent: 'true',
        type
      }
    }
  );
}

/** Number of rows of the import that were not matched with the inventory (only `totalItems` is used). */
export async function countNotLocatedWhiteBlackListing(processId: string): Promise<number> {
  const response = await sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}batch/import/results/whiteblacklisting/${processId}`,
    {
      method: 'GET',
      params: {
        filterStatus: 'notLocated',
        limit: 1,
        page: 1
      }
    }
  );
  return response?.totalItems ?? 0;
}

export async function processAllWhiteBlackListing(processId: string): Promise<any> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}batch/import/results/whiteblacklisting/${processId}`,
    {
      method: 'GET',
      params: {
        filterStatus: 'located',
        limit: 'unlimited',
        order: 'desc',
        page: 1,
        sortBy: 'status'
      }
    }
  );
}
